import { render } from "./CadastroLicenca.vue?vue&type=template&id=5934571f"
import script from "./CadastroLicenca.vue?vue&type=script&lang=ts"
export * from "./CadastroLicenca.vue?vue&type=script&lang=ts"
script.render = render

export default script